import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface FieldLabelProps {
  className?: string
  isUpdated?: boolean
  dontHideOverflow?: boolean
  testId?: string
  ariaLabel?: string
  htmlFor?: string
}

const FieldLabel: React.FC<React.PropsWithChildren<FieldLabelProps>> = (
  props,
): React.ReactElement => {
  return (
    <label
      className={props.className}
      data-testid={props.testId}
      aria-label={props.ariaLabel}
      htmlFor={props.htmlFor}
      css={css`
        ${getFontCss(
          14,
          styleConstants.colors.gray_darkest,
          styleConstants.fontFamilies.regular,
        )};
        white-space: nowrap;
        margin-bottom: 8px;
        ${!props.dontHideOverflow &&
        css`
          overflow: hidden;
        `}
        text-overflow: ellipsis;

        ${!!props.isUpdated &&
        css`
          ${getFontCss(
            14,
            themeConstants.colors.highlight,
            styleConstants.fontFamilies.regular,
          )};
        `}
      `}
    >
      {props.children}
    </label>
  )
}

export default FieldLabel
